/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { createDefaultGridModel } from '@gh/common-internal-shared';
import { getRouteInitData } from '@gh/common-shared';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import { GridDefinitionFactory, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import {
  getJeColorSelectionId,
  JeColorSelection,
} from '../../../resources/job-estimate-details.model';

@Component({
  standalone: false,
  selector: 'gh-je-details-color-selection-list',
  templateUrl: 'je-details-color-selection-list.component.html',
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JeDetailsColorSelectionListComponent implements OnInit {
  @Input() data: JeColorSelection[] = [];

  gridDefinition: LayoutBasedGridDefinition;

  constructor(private route: ActivatedRoute,
              private gridDefinitionFactory: GridDefinitionFactory) {

  }

  ngOnInit(): void {
    const { colorSelectionGridLayout } = getRouteInitData(this.route);
    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBasedWithModel({
      model: createDefaultGridModel({
        getId: getJeColorSelectionId,
      }),
      layout: colorSelectionGridLayout,
    });
  }
}
